// Import model
import { SfProposalLine } from '../models/SfProposalLine';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SfProposalLine - handles JSON serialization and deserialization with type validation
 */
export class SfProposalLineSerializer {
  /**
   * Deserializes a JSON string into a SfProposalLine instance
   */
  static deserialize(json: string): SfProposalLine {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SfProposalLine instance
   */
  static fromObject(obj: any): SfProposalLine {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SfProposalLine');
    }


    const instance: SfProposalLine = {
      externalId: obj['externalId'] as string | undefined,
      isDeleted: obj['isDeleted'] as boolean | undefined,
      sku: obj['sku'] as string | undefined,
      proposalExternalId: obj['proposalExternalId'] as string | undefined,
      proposalExternalIdName: obj['proposalExternalId|Name'] as string | undefined,
      quantity: obj['quantity'] as number | undefined,
      description: obj['description'] as string | undefined,
      margin: obj['margin'] as number | undefined,
      cost1: obj['cost1'] as number | undefined,
      wasteFactor: obj['wasteFactor'] as number | undefined,
      totalPrice: obj['totalPrice'] as number | undefined,
      totalCost: obj['totalCost'] as number | undefined,
      unitPrice: obj['unitPrice'] as number | undefined,
      unitCost: obj['unitCost'] as number | undefined,
      isDiscount: obj['isDiscount'] as boolean | undefined,
      itemExternalId: obj['itemExternalId'] as string | undefined,
      itemExternalIdName: obj['itemExternalId|Name'] as string | undefined,
      cost2: obj['cost2'] as number | undefined,
      price1: obj['price1'] as number | undefined,
      price2: obj['price2'] as number | undefined,
      index: obj['index'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SfProposalLine instances
   */
  static deserializeArray(json: string): SfProposalLine[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SfProposalLine instance to a JSON string
   */
  static serialize(instance: SfProposalLine): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SfProposalLine instance to a plain object
   */
  static toObject(instance: SfProposalLine): any {
    return {
      'externalId': instance.externalId,
      'isDeleted': instance.isDeleted,
      'sku': instance.sku,
      'proposalExternalId': instance.proposalExternalId,
      'proposalExternalId|Name': instance.proposalExternalIdName,
      'quantity': instance.quantity,
      'description': instance.description,
      'margin': instance.margin,
      'cost1': instance.cost1,
      'wasteFactor': instance.wasteFactor,
      'totalPrice': instance.totalPrice,
      'totalCost': instance.totalCost,
      'unitPrice': instance.unitPrice,
      'unitCost': instance.unitCost,
      'isDiscount': instance.isDiscount,
      'itemExternalId': instance.itemExternalId,
      'itemExternalId|Name': instance.itemExternalIdName,
      'cost2': instance.cost2,
      'price1': instance.price1,
      'price2': instance.price2,
      'index': instance.index,
    };
  }

  /**
   * Serializes an array of SfProposalLine instances to a JSON string
   */
  static serializeArray(instances: SfProposalLine[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
